export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/chevron-right-white.png?56e86e127cf2dd6457b56e621ab05124";